import { useEffect, useState } from "react";

import "../css/PopupPrintingSale.css";

import ButtonIconH from "../../components/ButtonIconH";
import CheckBox from "../../components/CheckBox";
import Dropdown from "../../components/Dropdown";
import LoadingScreen from "../../components/LoadingScreen";
import { generateDocument } from "./PopupInvoicePrintingSimple";

export default ({
  show,
  title = "Imprimir",
  endpoint,
  buildParams = () => ({}),
  documentOptions = [],
  isDocumentEditable = () => true,
  errorMessage = "Error al generar el documento.",
  onClose,
  onSent,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [printObservations, setPrintObservations] = useState(false);
  const [sending, setSending] = useState(false);
  const isEditable = isDocumentEditable(selectedDocument?.id);

  const selectDocument = (item) => {
    setSelectedDocument(item);
    if (!isDocumentEditable(item?.id)) {
      setPrintObservations(false);
    }
  };

  useEffect(() => {
    if (show) {
      selectDocument(documentOptions[documentOptions.length - 1] ?? null);
      setPrintObservations(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const sendEmail = async () => {
    if (!selectedDocument) return;

    setSending(true);
    const response = await generateDocument({
      endpoint,
      params: buildParams(selectedDocument.id),
      printObservations,
      errorMessage,
      createPopupQuestion,
      removePopupQuestion,
    });
    setSending(false);

    if (!response) return;

    onClose();
    onSent({
      titulo: response.nombreFichero,
      fichero: response.fichero,
    });
  };

  return (
    show && (
      <div className="popup-container popup-normal popup-printing-sale">
        <div className="popup-message">
          <div className="popup-header">
            <div className="popup-title">{title}</div>
            <img
              src="/images/close-white.svg"
              loading="lazy"
              alt=""
              className="popup-close"
              onClick={onClose}
            />
          </div>
          <div className="popup-body">
            {sending && <LoadingScreen message="" />}
            <div className="popup-row">
              <div className="label">Documento</div>
              <Dropdown
                id="printing-sale-simple-document"
                disabled={false}
                optionList={documentOptions.map((item) => ({
                  ...item,
                  text: (item.text ?? "").toUpperCase(),
                }))}
                size={2}
                op={selectedDocument ? selectedDocument.id : null}
                onChange={selectDocument}
              />
            </div>
            <div className="popup-row popup-row-checks">
              <div
                className={`data-field ${isEditable ? "c-pointer" : ""}`}
                onClick={() =>
                  isEditable && setPrintObservations((prev) => !prev)
                }
              >
                <CheckBox
                  active={printObservations}
                  disabled={!isEditable}
                  onClick={() => {}}
                />
                <span className="label">Imprimir observaciones</span>
              </div>
            </div>
          </div>
          <div className="popup-footer">
            <div className="popup-row-buttons">
              <ButtonIconH
                text="Enviar email"
                disabled={sending}
                onClick={sendEmail}
              />
            </div>
          </div>
        </div>
      </div>
    )
  );
};
